<form #optionForm="ngForm">
    <mat-form-field class="chip-list">
        <mat-label>Options</mat-label>
        <mat-chip-grid #chipGrid aria-label="Options">
            @for (entity of multiPickEntitiesFormCtrl(); track $index) {
                <mat-chip-row (removed)="remove(entity)">
                    {{ entity.displayName }}
                    <button matChipRemove [attr.aria-label]="'remove ' + entity.displayName" type="button">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            }
        </mat-chip-grid>
        <input
            name="currentEntity"
            placeholder="New Option"
            #input
            #optionInput="ngModel"
            [(ngModel)]="currentEntity"
            [matChipInputFor]="chipGrid"
            [matAutocomplete]="auto"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)"
            (paste)="paste($event)"
            required />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" [displayWith]="displayFn">
            @for (entities of filteredEntities(); track $index) {
                <mat-option [value]="entities">{{ entities.displayName }}</mat-option>
            }
        </mat-autocomplete>
    </mat-form-field>
    <!-- Mat Chips are finicky to validate -->
    @if (multiPickEntitiesFormCtrl().length < 1 && optionInput.touched) {
        <mat-error>Value required</mat-error>
    }
    @if (invalidDataPastedIn().length > 0) {
        <mat-error id="invalid-data-error"
            >Invalid data
            <button id="invalid-data-error-button" (click)="openInvalidDataDialog()" mat-stroked-button type="button">
                See Invalid Data
            </button></mat-error
        >
    }
</form>
